import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';

var AnchorComponent = function AnchorComponent(props) {
  return React.createElement("a", props);
};

export var getBreadcrumbChildren = function getBreadcrumbChildren(props, segment) {
  var _cx;

  var darkColor = props.darkColor,
      classes = props.classes,
      render = props.render;
  /** @type {React.ComponentType} */

  var ContentComponent = null;
  var contentComponentProps = {};

  if (typeof render === 'function') {
    var element = render(segment);
    if (element == null) return null;
    var isNode = true;

    if (typeof element === 'object') {
      if (typeof element.componentProps === 'object') {
        isNode = false;
        contentComponentProps = _objectSpread({}, contentComponentProps, element.componentProps);
      }

      if (typeof element.component !== 'undefined') {
        isNode = false;
        ContentComponent = element.component;
      }
    }

    if (isNode) contentComponentProps.children = element;
  }

  ContentComponent = ContentComponent || AnchorComponent;
  if (!contentComponentProps.children) contentComponentProps.children = segment.name;
  contentComponentProps.className = cx((_cx = {}, _defineProperty(_cx, contentComponentProps.className, true), _defineProperty(_cx, classes.link, true), _defineProperty(_cx, classes.linkDark, darkColor), _defineProperty(_cx, classes.linkLight, !darkColor), _defineProperty(_cx, classes.lastLink, segment.isLast), _cx));
  return React.createElement(ContentComponent, contentComponentProps);
};
/**
 * @extends {React.Component<import('./types').BreadcrumbProps> }
 */

var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  function Breadcrumb() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Breadcrumb);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Breadcrumb)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          onNavigateTo = _this$props.onNavigateTo,
          segment = _this$props.segment;
      e.preventDefault();
      onNavigateTo(segment.path, segment);
    };

    _this.onKeyPress = function (e) {
      if (e.key === 'Enter') return _this.handleClick(e);
      if (e.key === 'Space') return _this.handleClick(e);
    };

    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          typographyProps = _this$props2.typographyProps,
          onNavigateTo = _this$props2.onNavigateTo,
          tabIndex = _this$props2.tabIndex,
          id = _this$props2.id;
      var content = this.props.children;
      var typographyRenderedProps = typographyProps || {};
      typographyRenderedProps.style = typographyRenderedProps.style || {};

      if (onNavigateTo) {
        typographyRenderedProps = _objectSpread({}, typographyRenderedProps, {
          onClick: this.handleClick,
          onKeyPress: this.onKeyPress,
          tabIndex: tabIndex,
          id: id
        });
      }

      typographyRenderedProps.style = _objectSpread({
        outlineColor: 'grey'
      }, typographyRenderedProps.style);
      return React.createElement(Typography, typographyRenderedProps, content);
    }
  }]);

  return Breadcrumb;
}(React.Component);

export default Breadcrumb;